const chartColumns = [
  { label: 'Total Capacity - Host count', accessor: 'host_count'},
  { label: 'Total Capacity - Total Cores', accessor: 'host_cpu_cores'},
  { label: 'Total Capacity - Memory', accessor: 'host_memory_total_gb'},
  { label: 'Usage - VM count', accessor: 'vm_count'},
  { label: 'Usage - Allocated CPU (cores)', accessor: 'num_cpu'},
  { label: 'Usage - Allocated Memory', accessor: 'cluster_allocated_memory_gb'},
  { label: 'Usage - Avg CPU usage', accessor: 'average_cpu_percent'},
  { label: 'Usage - Avg memory usage', accessor: 'average_memory_percent'},
  { label: 'Available - CPU (cores)', accessor: 'available_cpu_n1'},
  { label: 'Available - Memory', accessor: 'n1_available_cluster_memory_gb'},
  { label: 'Available - CPU %', accessor: 'available_cpu_percent'},
  { label: 'Available - Memory %', accessor: 'available_memory_percent'}
];

export { chartColumns }